class PfCountdown extends HTMLElement {
  connectedCallback() {
    this.digitEls = this.querySelectorAll("[data-digit]");
    this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    this.endTime = this.resolveEndTime();
    this.tick();
    this.intervalId = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    if (this.intervalId) clearInterval(this.intervalId);
  }

  resolveEndTime() {
    const raw = (this.dataset.end || "").trim();
    const now = Date.now();
    const parsed = raw ? this.parseEnd(raw) : NaN;

    if (!Number.isNaN(parsed) && parsed > now) {
      return parsed;
    }

    // Blank, invalid, or past → 10 days from now
    return now + 10 * 24 * 60 * 60 * 1000;
  }

  parseEnd(raw) {
    const match = raw.match(
      /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2})(?::(\d{2}))?)?$/
    );
    if (match) {
      return new Date(
        Number(match[1]),
        Number(match[2]) - 1,
        Number(match[3]),
        Number(match[4] || 0),
        Number(match[5] || 0),
        Number(match[6] || 0)
      ).getTime();
    }
    return Date.parse(raw);
  }

  tick() {
    const remaining = this.endTime - Date.now();

    if (remaining <= 0) {
      this.render(0, 0, 0, 0);
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    this.render(days, hours, mins, secs);
  }

  render(days, hours, mins, secs) {
    const values = [
      this.pad2(days),
      this.pad2(hours),
      this.pad2(mins),
      this.pad2(secs),
    ];

    this.digitEls.forEach((el) => {
      const unit = Number(el.dataset.unit);
      const place = Number(el.dataset.place);
      const next = values[unit][place];
      this.flipDigit(el, next);
    });
  }

  flipDigit(card, next) {
    const current = card.dataset.value || "0";
    if (current === next) return;

    const topStatic = card.querySelector(
      ".pf-countdown__half--top:not(.pf-countdown__half--flip) .pf-countdown__half-num"
    );
    const bottomStatic = card.querySelector(
      ".pf-countdown__half--bottom:not(.pf-countdown__half--flip) .pf-countdown__half-num"
    );

    if (this.reduceMotion || !topStatic || !bottomStatic) {
      card.dataset.value = next;
      if (topStatic) topStatic.textContent = next;
      if (bottomStatic) bottomStatic.textContent = next;
      return;
    }

    card.querySelectorAll(".pf-countdown__half--flip").forEach((node) => node.remove());

    const topFlip = document.createElement("div");
    topFlip.className = "pf-countdown__half pf-countdown__half--top pf-countdown__half--flip";
    topFlip.innerHTML = `<span class="pf-countdown__half-num">${current}</span>`;

    const bottomFlip = document.createElement("div");
    bottomFlip.className = "pf-countdown__half pf-countdown__half--bottom pf-countdown__half--flip";
    bottomFlip.innerHTML = `<span class="pf-countdown__half-num">${next}</span>`;

    // New digit waits under the folding top; old bottom stays until lower flap lands
    topStatic.textContent = next;
    card.appendChild(topFlip);
    card.appendChild(bottomFlip);
    card.dataset.value = next;

    // Force reflow so the browser applies the starting transform before animating
    void topFlip.offsetWidth;
    topFlip.classList.add("is-flipping");
    bottomFlip.classList.add("is-flipping");

    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      bottomStatic.textContent = next;
      topFlip.remove();
      bottomFlip.remove();
    };

    bottomFlip.addEventListener("animationend", finish, { once: true });
    setTimeout(finish, 800);
  }

  pad2(n) {
    const clamped = Math.max(0, Math.min(99, Math.floor(n)));
    return String(clamped).padStart(2, "0");
  }
}

if (!customElements.get("pf-countdown")) {
  customElements.define("pf-countdown", PfCountdown);
}
